import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StationFacade } from '@app/station/station.facade';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ExternalLinkConfirmDirective } from "@app/shared/directives/external-link.directive";

@Component({
    selector: 'app-lexicon-detail',
    templateUrl: './lexicon-detail.component.html',
    styleUrls: ['./lexicon-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe, ExternalLinkConfirmDirective]
})
export class LexiconDetailComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly facade = inject(StationFacade);
  private readonly lexiconStations = this.facade.lexioconStationsSignal;

  protected readonly translate = inject(TranslateService);
  protected lexiconEntry = computed(() => this.lexiconStations().find(station => this.route.toString().includes(station.id)));

}
